import LoadingSpinner from "@components/LoadingSpinner";
import * as React from "react";
import styled from "styled-components";

const Container = styled.div`
  width: 100vw;
  height: 100vh;
  position: absolute;
  left: 0;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white;
`;

const Loading: React.FC = () => {
  return (
    <Container>
      <LoadingSpinner />
    </Container>
  );
};

export default Loading;
